/** Búsqueda de customers para uso en POS (autocomplete del PaymentDialog). */
import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { api } from "@/lib/api.ts";
import type { CustomerOut } from "@/types/api.ts";

export const customerKeys = {
  all: ["customers"] as const,
  search: (q: string) => [...customerKeys.all, "search", q] as const,
};

/** Mín 2 chars para evitar traer todo el padrón. enabled controla el dispatch. */
export function useSearchCustomers(q: string) {
  const trimmed = q.trim();
  return useQuery({
    queryKey: customerKeys.search(trimmed),
    queryFn: () =>
      api.get<CustomerOut[]>("/customers", {
        searchParams: { q: trimmed, limit: 10 },
      }),
    enabled: trimmed.length >= 2,
    placeholderData: keepPreviousData,
    staleTime: 30_000,
  });
}
